




























































import { Vue, Component, Prop } from "vue-property-decorator";
import { LectureShort as ILectureShort } from "@/api/models/lecture-short";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
@Component({
  components: { CustomTableItem, CustomTableCol }
})
export default class LectureListItem extends Vue {
  @Prop() lecture!: ILectureShort;
}
